import { Component, Prop, Vue } from 'vue-property-decorator';
import { Events, Items, Props } from './types';

const { CHANGE } = Events;

@Component
export default class ComponentPartTabMenu extends Vue implements Props {
  // Props
  @Prop({ type: Array, default: '' })
  items: Items;

  @Prop({ type: Number, default: -1 })
  current: number;

  // Computed
  get list() {
    return this.items.map((item, index) => ({
      ...item,
      classes: { 'tabs-menu__link_current': this.isSelected(index) },
    }));
  }

  // Methods
  isSelected(index: number) {
    return index === this.current;
  }

  onClick(index: number) {
    this.$emit(CHANGE, index);
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/tab/menu/script.ts